import { Navigate } from 'react-router';

export default function CustomersIndex() {
  return <Navigate to="/customers/live" replace />;
}
